import React, { useEffect, useState } from "react";
import MultiChart from "./MultiChart";
import { useWeatherDetailsDashboaredMutation } from "../../../../features/bau/dashboardDetailsApi";
import { useParams } from "react-router-dom";
import RoseChart from "./RoseChart";
import timeAgo from "../../../../helper/timeAgo";
import CompassDirectionLabel from "../compass/CompassDirectionLabel";

function GaugeDetailsPage() {
  const { sensorId } = useParams();
  const [detailsData, setDetailsData] = useState();

  const [weatherDetailsDashboared, { isLoading }] =
    useWeatherDetailsDashboaredMutation();
  useEffect(() => {
    weatherDetailsDashboared({ sensor_id: sensorId })
      .unwrap()
      .then((payload) => {
        setDetailsData(payload.data);
      })
      .catch((error) => console.log(error));
  }, [sensorId]);

  const handleChangeDays = (day) => {
    weatherDetailsDashboared({ sensor_id: sensorId, day })
      .unwrap()
      .then((payload) => {
        setDetailsData(payload.data);
      })
      .catch((error) => console.log(error));
  };
  let time_ago = "";
  if (!isLoading) {
    let latestTimeStamp = new Date(detailsData?.updated_at);
    // console.log(latestTimeStamp);

    if (latestTimeStamp) {
      time_ago = timeAgo(latestTimeStamp);
    }
  }

  return (
    <div>
      <div
        className="card theme-background "
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div
          className="brri-timestamp theme-text"
          style={{
            textAlign: "center",
            padding: "10px",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {detailsData?.sensor_name} : {detailsData?.value} {detailsData?.unit}
          {sensorId == "121" && (
            <span className="theme-text" style={{ display: "inline-flex" }}>
              {"("} <CompassDirectionLabel degreeValue={detailsData?.value} />{" "}
              {")"}
            </span>
          )}
        </div>
        <div
          className="brri-timestamp theme-text"
          style={{ textAlign: "center", padding: "10px", fontSize: "18px" }}
        >
          {/* Last Updated : {time_ago} (BAU) */}
          Last Updated : {time_ago}
        </div>
      </div>

      <div class="form-group">
        <label class="form-label theme-text" for="premises no">
          Select Day's
        </label>
        <select
          required
          name="premises_id"
          class="form-control form-select"
          onChange={(e) => {
            handleChangeDays(e.target.value);
          }}
          // defaultValue={updateFormData?.premises_id || ""}
        >
          <option value="7">7 Days</option>
          <option value="15">15 Days</option>
          <option value="30">30 Days</option>
        </select>
      </div>
      {sensorId != "121" && <MultiChart multiChartData={detailsData} />}
      {sensorId == "121" && <RoseChart roseChartData={detailsData} />}
    </div>
  );
}

export default GaugeDetailsPage;
